<template>
    <form id="upgrade-form" ref="upgradeForm" method="post" class="cmp-fleet-upgrade td-card rounded border shadow td-form">
        <div class="td-banner info no-icon border upgrade">
            <h5 class="td-h4 mb-1">Upgrade your account for only $499/yr</h5>
            <p>
                A Fleet Account provides more advanced search options and better controls over your search results for your whole team.
                Designed for larger teams managing a large fleet of trucks, a Fleet Account can help you <strong>save money</strong> and
                <strong>reduce time on repairs</strong> for your whole fleet.
                <a class="td-link" title="Information about fleet accounts" href="/shop/fleets">See our Fleets page for more information …</a>
            </p>
            <p class="mt-3 hint">
                <strong>You do not need to upgrade to use our search services!</strong> Your current account provides all the
                services needed to support smaller teams, fleets, and owner/operators and will always be free.
            </p>
        </div>
       
        <p class="mt-4">My team can benefit from a Fleet Account. Please contact me at:</p>

        <input type="hidden" :name="context.antiforgeryToken.field" :value="context.antiforgeryToken.token" />
        <p v-if="error" class="td-error">{{ error }}</p>

        <label for="name" class="td-label mt-1">Name</label>
        <input type="text" name="Name" v-model="name" id="name" placeholder="Enter name" />
        <p v-if="v$.name.$error" class="td-error">Please provide your name.</p>

        <label for="email" class="td-label mt-1">Email</label>
        <input type="email" name="Email" v-model="email" id="email" placeholder="Enter email address" />
        <p v-if="v$.email.$error" class="td-error">Please provide a valid email to reach you.</p>

        <label for="phone" class="td-label mt-1">Phone</label>
        <input type="text" name="Phone" v-model="phone" id="phone" placeholder="Enter phone number" />
        <p v-if="v$.phone.$error" class="td-error">Please provide a valid phone number to reach you.</p>

        <div class="captcha-container mt-2">
            <captcha :return-response="true" instance="fleet-upgrade"></captcha>
            <input v-model="captchaReturn" name="CaptchaReturn" type="hidden" />
            <p v-if="v$.captchaReturn.$error" class="td-error">Please verify that you are not an automated bot.</p>
        </div>
        <p class="my-3 td-banner no-icon">Once you submit this request, TruckDown will contact you at the information provided to discuss upgrading your account. </p>
        <div class="actions">
            <button class="td-btn secondary-outlined return" title="Return to previous page" @click.prevent="returnToPrevious">Return to Previous Page</button>
            <button type="submit" @click.prevent="submitForm($event)" class="td-btn primary">Submit Request</button>
        </div>
    </form>
</template>

<script>import script from './FleetUpgrade';
    export default script;</script>

<style lang="less">
    @import "./FleetUpgrade.less";
</style>
